import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import MRAdditionalOptions from './MRAdditionalOptions';

export default styled(MRAdditionalOptions)`
  .label {
    color: var(--grey700);
    margin: 0;
  }

  .title {
    font-weight: 500;
    font-size: 2.4rem;
    color: var(--grey900);
    margin: ${gridSizes('M')} 0 0 0;
  }

  .subtitle {
    font-size: 1.6rem;
    margin: ${gridSizes('S')} 0;
    color: var(--grey500);
  }

  .download-deca {
    display: flex;
    align-items: center;
    gap: ${gridSizes('S')};
    margin-top: ${gridSizes('M')};
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
  }
`;
